import {ValidatableEmail} from 'Core/models/Email';
import {ValidatablePhone} from 'Core/models/PhoneNumber';
import {ValidatableNonEmptyString} from 'Core/models/ValidatableNonEmptyString';
import * as I from 'immutable';
import {createAction} from 'Shared/utilities/actionCreator';
import agentSupportUserType, {
  AgentSupportUserTypeAction,
  AgentSupportUserTypeActionType,
} from 'Users/ducks/agentSupportUserType';
import agentUserTypeReducer, {AgentUserTypeAction, AgentUserTypeActionType} from 'Users/ducks/agentUserType';
import fieldSalesLeaderUserType, {
  FieldSalesLeaderUserTypeAction,
  FieldSalesLeaderUserTypeActionType,
} from 'Users/ducks/fieldSalesLeaderUserType';
import fieldVicePresidentUserType, {
  FieldVicePresidentUserTypeAction,
  FieldVicePresidentUserTypeActionType,
} from 'Users/ducks/fieldVicePresidentUserType';
import vipUserType, {VIPUserTypeAction, VipUserTypeActionType} from 'Users/ducks/vipUserType';
import {LineOfBusiness} from 'Users/models/LineOfBusiness';
import {EmptyAgentSupportUserType} from 'Users/models/User/Agent/AgentSupportUserType';
import {EmptyAgentUserType} from 'Users/models/User/Agent/AgentUserType';
import {EmptyFieldSalesLeaderUserType} from 'Users/models/User/Agent/FieldSalesLeaderUserType';
import {EmptyFieldVicePresidentUserType} from 'Users/models/User/Agent/FieldVicePresidentUserType';
import {DefaultVIPUserType} from 'Users/models/User/Agent/VipUserType';
import {
  AgentRole,
  AgentUserType,
  InvalidAgentUserType,
  matchAgentUserType,
  UndeterminedAgentUserType,
  ValidAgentUserType,
} from 'Users/models/User/AgentUserType';
import {AccountType} from 'Users/models/User/BasicInformation';
import {AdminUserType as BeneficiariesAdminUserType} from 'Users/models/User/Beneficiaries/AdminUserType';
import {
  BeneficiariesRole,
  InvalidBeneficiariesUserType,
  ValidBeneficiariesUserType,
} from 'Users/models/User/BeneficiariesUserType';
import {AdminUserType as BosToolsAdminUserType} from 'Users/models/User/BosTools/AdminUserType';
import {BosToolsRole, InvalidBosToolsUserType, ValidBosToolsUserType} from 'Users/models/User/BosToolsUserType';
import {
  EnrollTrackRole,
  InvalidEnrollmentTrackingUserType,
  ValidEnrollmentTrackingUserType,
} from 'Users/models/User/EnrollmentTrackingUserType';
import {AdminUserType as MessagingAdminUserType} from 'Users/models/User/Messaging/AdminUserType';
import {ManagerUserType as MessagingManagerUserType} from 'Users/models/User/Messaging/ManagerUserType';
import {MessageSenderUserType} from 'Users/models/User/Messaging/MessageSenderUserType';
import {AdminUserType as EnrollTrackAdminUserType} from 'Users/models/User/EnrollTrack/AdminUserType';
import {AgentUserType as EnrollTrackAgentUserType} from 'Users/models/User/EnrollTrack/AgentUserType';
import {BrokerUserType} from 'Users/models/User/EnrollTrack/BrokerUserType';
import {ClientOnboardingUserType} from 'Users/models/User/EnrollTrack/ClientOnboardingUserType';
import {DirectorUserType} from 'Users/models/User/EnrollTrack/DirectorUserType';
import {EmployerUserType} from 'Users/models/User/EnrollTrack/EmployerUserType';
import {EtsEnrollmentOperationsUserType} from 'Users/models/User/EnrollTrack/EtsEnrollmentOperationsUserType';
import {EtsLeadershipUserType} from 'Users/models/User/EnrollTrack/EtsLeadershipUserType';
import {SalesSupportUserType} from 'Users/models/User/EnrollTrack/SalesSupportUserType';
import {SalesDistributionUserType} from 'Users/models/User/EnrollTrack/SalesDistributionUserType';
import {FileAnalystUserType} from 'Users/models/User/EnrollTrack/FileAnalystUserType';
import {FileManagementUserType} from 'Users/models/User/EnrollTrack/FileManagementUserType';
import {ManagerUserType} from 'Users/models/User/EnrollTrack/ManagerUserType';
import {HomeOfficeUserType} from 'Users/models/User/EnrollTrack/HomeOfficeUserType';
import {EnrollmentTechnologyPartnerUserType} from 'Users/models/User/EnrollTrack/EnrollmentTechnologyPartnerUserType';
import * as U from 'Users/models/User/User';
import {ValidUser} from 'Users/models/User/User';
import {
  InvalidUserType,
  InvalidUserTypeValue,
  matchUserTypeByLineOfBusiness,
  UserType,
  ValidUserType,
  ValidUserTypeValue,
} from 'Users/models/User/UserType';
import {EtsDataOperationsUserType} from './../models/User/EnrollTrack/EtsDataOperationsUserType';
import {MessagingRole, InvalidMessagingUserType, ValidMessagingUserType} from 'Users/models/User/MessagingUserType';
import {MessageAnalystUserType} from 'Users/models/User/Messaging/MessageAnalystUserType';
import {InvalidAppEntryUserType, AppEntryRole, ValidAppEntryUserType} from 'Users/models/User/AppEntryUserType';
import {KeyerUserType} from 'Users/models/User/AppEntry/KeyerUser';

export enum UserEntryActionType {
  ADD_USER_TYPE = 'userEntry/ADD_USER_TYPE',
  REMOVE_USER_TYPE = 'userEntry/REMOVE_USER_TYPE',
  GET_USER_DETAIL = 'userEntry/GET_USER_DETAIL',
  CLEAR_STATE = 'userEntry/CLEAR_STATE',
  CHANGE_AGENT_ROLE = 'userEntry/CHANGE_AGENT_ROLE',
  CHANGE_APPENTRY_ROLE = 'userEntry/CHANGE_APPENTRY_ROLE',
  CHANGE_BOS_TOOLS_ROLE = 'userEntry/CHANGE_BOS_TOOLS_ROLE',
  CHANGE_BENEFICIARIES_ROLE = 'userEntry/CHANGE_BENEFICIARIES_ROLE',
  CHANGE_MESSAGING_ROLE = 'userEntry/CHANGE_MESSAGING_ROLE',
  CHANGE_ACCOUNT_TYPE = 'userEntry/CHANGE_ACCOUNT_TYPE',
  CHANGE_EMAIL = 'userEntry/CHANGE_EMAIL',
  CHANGE_ENROLL_TRACK_ROLE = 'userEntry/CHANGE_ENROLL_TRACK_ROLE',
  CHANGE_FIRST_NAME = 'userEntry/CHANGE_FIRST_NAME',
  CHANGE_LAST_NAME = 'userEntry/CHANGE_LAST_NAME',
  CHANGE_PHONE = 'userEntry/CHANGE_PHONE',
  CHANGE_USER_NAME = 'userEntry/CHANGE_USER_NAME',
  VALIDATE_EMAIL = 'userEntry/VALIDATE_EMAIL',
  VALIDATE_PHONE = 'userEntry/VALIDATE_PHONE',
  VALIDATE_USERNAME = 'userEntry/VALIDATE_USERNAME',
  ADD_USER = 'userEntry/ADD_USER',
  UPDATE_USER = 'userEntry/UPDATE_USER',
  SHOW_ERROR = 'userEntry/SHOW_ERROR',
  CHANGE_IS_USER_SUPPORT = 'userEntry/CHANGE_IS_USER_SUPPORT',
  VALIDATE_FIRST_NAME = 'userEntry/VALIDATE_FiRST_NAME',
  VALIDATE_LAST_NAME = 'userEntry/VALIDATE_LAST_NAME',
}

const reverseEnum = <TEnum>(enumeration: TEnum) =>
  Object.entries(enumeration)
    .map(([key, value]) => ({[value]: key}))
    .reduce((prev, curr) => ({...prev, ...curr}));

const isFieldVicePresidentUserTypeAction = (action: UserEntryAction): action is FieldVicePresidentUserTypeAction => {
  const {type} = action;

  return type in reverseEnum(FieldVicePresidentUserTypeActionType);
};

const isFieldSalesLeaderUserTypeAction = (action: UserEntryAction): action is FieldSalesLeaderUserTypeAction => {
  const {type} = action;

  return type in reverseEnum(FieldSalesLeaderUserTypeActionType);
};

const isAgentSupportUserTypeAction = (action: UserEntryAction): action is AgentSupportUserTypeAction => {
  const {type} = action;

  return type in reverseEnum(AgentSupportUserTypeActionType);
};

const isVipUserTypeAction = (action: UserEntryAction): action is VIPUserTypeAction => {
  const {type} = action;

  return type in reverseEnum(VipUserTypeActionType);
};

const isAgentUserTypeAction = (action: UserEntryAction): action is AgentUserTypeAction => {
  const {type} = action;

  return type in reverseEnum(AgentUserTypeActionType);
};

export const changeAccountType = (accountType: AccountType) =>
  createAction(UserEntryActionType.CHANGE_ACCOUNT_TYPE, {accountType});
export const changeFirstName = (firstName: ValidatableNonEmptyString) =>
  createAction(UserEntryActionType.CHANGE_FIRST_NAME, {firstName});
export const changeLastName = (lastName: ValidatableNonEmptyString) =>
  createAction(UserEntryActionType.CHANGE_LAST_NAME, {lastName});
export const changeEmail = (email: ValidatableEmail) => createAction(UserEntryActionType.CHANGE_EMAIL, {email});
export const changeUserName = (username: ValidatableNonEmptyString) =>
  createAction(UserEntryActionType.CHANGE_USER_NAME, {username});
export const changePhoneNumber = (phoneNumber: ValidatablePhone) =>
  createAction(UserEntryActionType.CHANGE_PHONE, {phoneNumber});
export const changeAgentRole = (agentRole: AgentRole) =>
  createAction(UserEntryActionType.CHANGE_AGENT_ROLE, {agentRole});
export const changeAppEntryRole = (appEntryRole: AppEntryRole) =>
  createAction(UserEntryActionType.CHANGE_APPENTRY_ROLE, {appEntryRole});
export const changeBosToolsRole = (bosToolsRole: BosToolsRole) =>
  createAction(UserEntryActionType.CHANGE_BOS_TOOLS_ROLE, {bosToolsRole});
export const changeBeneficiariesRole = (beneficiariesRole: BeneficiariesRole) =>
  createAction(UserEntryActionType.CHANGE_BENEFICIARIES_ROLE, {beneficiariesRole});
export const changeEnrollTrackRole = (enrollTrackRole: EnrollTrackRole) =>
  createAction(UserEntryActionType.CHANGE_ENROLL_TRACK_ROLE, {enrollTrackRole});
export const changeIsUserSupport = (isUserSupport: boolean) =>
  createAction(UserEntryActionType.CHANGE_IS_USER_SUPPORT, {isUserSupport});
export const changeMessagingRole = (messagingRole: MessagingRole) =>
  createAction(UserEntryActionType.CHANGE_MESSAGING_ROLE, {messagingRole});
export const validateEmail = (email: string) => createAction(UserEntryActionType.VALIDATE_EMAIL, email);
export const validateUserName = (username: string) => createAction(UserEntryActionType.VALIDATE_USERNAME, username);
export const validatePhoneNumber = (phone: string) => createAction(UserEntryActionType.VALIDATE_PHONE, phone);
export const validateFirstName = (firstName: string) =>
  createAction(UserEntryActionType.VALIDATE_FIRST_NAME, firstName);
export const validateLastName = (lastName: string) => createAction(UserEntryActionType.VALIDATE_LAST_NAME, lastName);
export const addAccessFromLineOfBusiness = (lineOfBusiness: LineOfBusiness) =>
  createAction(UserEntryActionType.ADD_USER_TYPE, {lineOfBusiness});
export const removeUserType = (userType: ValidUserTypeValue | InvalidUserTypeValue) =>
  createAction(UserEntryActionType.REMOVE_USER_TYPE, {userType});
export const getUserDetail = (userId: string) => createAction(UserEntryActionType.GET_USER_DETAIL, {userId});
export const addUser = (user: ValidUser) => createAction(UserEntryActionType.ADD_USER, {user});
export const updateUser = (user: ValidUser, userId: string) =>
  createAction(UserEntryActionType.UPDATE_USER, {user, userId});
export const clearState = () => createAction(UserEntryActionType.CLEAR_STATE);
export const showError = (user: ValidUser) => createAction(UserEntryActionType.SHOW_ERROR, {user});

const getUserTypeFromLineOfBusiness = (lineOfBusiness: LineOfBusiness): UserType => {
  switch (lineOfBusiness) {
    case LineOfBusiness.Agent:
      return new InvalidUserType(new InvalidAgentUserType(new UndeterminedAgentUserType()));
    case LineOfBusiness.BOSTools:
      return new InvalidUserType(new InvalidBosToolsUserType());
    case LineOfBusiness.Beneficiary:
      return new InvalidUserType(new InvalidBeneficiariesUserType());
    case LineOfBusiness.EnrollmentTracking:
      return new InvalidUserType(new InvalidEnrollmentTrackingUserType());
    case LineOfBusiness.Messaging:
      return new InvalidUserType(new InvalidMessagingUserType());
    case LineOfBusiness.AppEntry:
      return new InvalidUserType(new InvalidAppEntryUserType());
  }
};

type UserEntryState = U.User;
const DEFAULT_STATE = U.EmptyUser;

export type UserEntryAction =
  | ReturnType<typeof updateUser>
  | ReturnType<typeof addUser>
  | ReturnType<typeof getUserDetail>
  | ReturnType<typeof changeAgentRole>
  | ReturnType<typeof changeBosToolsRole>
  | ReturnType<typeof validateEmail>
  | ReturnType<typeof changeEnrollTrackRole>
  | ReturnType<typeof changeIsUserSupport>
  | ReturnType<typeof changeAppEntryRole>
  | ReturnType<typeof changeBeneficiariesRole>
  | ReturnType<typeof changeMessagingRole>
  | ReturnType<typeof addAccessFromLineOfBusiness>
  | ReturnType<typeof changeAccountType>
  | ReturnType<typeof changeFirstName>
  | ReturnType<typeof changeLastName>
  | ReturnType<typeof changeUserName>
  | ReturnType<typeof changeEmail>
  | ReturnType<typeof changePhoneNumber>
  | ReturnType<typeof showError>
  | ReturnType<typeof removeUserType>
  | ReturnType<typeof clearState>
  | ReturnType<typeof validateFirstName>
  | ReturnType<typeof validateLastName>
  | VIPUserTypeAction
  | FieldSalesLeaderUserTypeAction
  | AgentUserTypeAction
  | AgentSupportUserTypeAction
  | FieldVicePresidentUserTypeAction;

const updateAgentUserType = (action: UserEntryAction) => (agentUserType: AgentUserType) => {
  const updatedAgentUserType = matchAgentUserType(agentUserType.value, {
    FieldSalesLeader: fslUserType => fieldSalesLeaderUserType(fslUserType, action as FieldSalesLeaderUserTypeAction),
    FieldVicePresident: fvpUserType =>
      fieldVicePresidentUserType(fvpUserType, action as FieldVicePresidentUserTypeAction),
    Agent: agent => agentUserTypeReducer(agent, action as AgentUserTypeAction),
    AgentSupport: agentSupport => agentSupportUserType(agentSupport, action as AgentSupportUserTypeAction),
    VIP: vip => vipUserType(vip, action as VIPUserTypeAction),
    Undetermined: () => agentUserType.value,
  });

  const validatedAgentUserType = ValidAgentUserType.create(updatedAgentUserType);

  return ValidUserType.create(validatedAgentUserType);
};

const initializeAgentByRole = (action: ReturnType<typeof changeAgentRole>) => {
  const {agentRole} = action.payload;

  switch (agentRole) {
    case AgentRole.VIP:
      return ValidUserType.create(ValidAgentUserType.create(DefaultVIPUserType));
    case AgentRole.FieldSalesLeader:
      return ValidUserType.create(ValidAgentUserType.create(EmptyFieldSalesLeaderUserType));
    case AgentRole.FieldVicePresident:
      return ValidUserType.create(ValidAgentUserType.create(EmptyFieldVicePresidentUserType));
    case AgentRole.Agent:
      return ValidUserType.create(ValidAgentUserType.create(EmptyAgentUserType));
    case AgentRole.AgentSupport:
      return ValidUserType.create(ValidAgentUserType.create(EmptyAgentSupportUserType));
    default:
      return new InvalidUserType(new InvalidAgentUserType(new UndeterminedAgentUserType()));
  }
};

const initializeEnrollTrackByRole = (action: ReturnType<typeof changeEnrollTrackRole>) => {
  const {enrollTrackRole} = action.payload;

  switch (enrollTrackRole) {
    case EnrollTrackRole.Admin:
      return ValidUserType.create(new ValidEnrollmentTrackingUserType(new EnrollTrackAdminUserType()));
    case EnrollTrackRole.FileAnalyst:
      return ValidUserType.create(new ValidEnrollmentTrackingUserType(new FileAnalystUserType()));
    case EnrollTrackRole.FileManagement:
      return ValidUserType.create(new ValidEnrollmentTrackingUserType(new FileManagementUserType()));
    case EnrollTrackRole.HomeOffice:
      return ValidUserType.create(new ValidEnrollmentTrackingUserType(new HomeOfficeUserType()));
    case EnrollTrackRole.Director:
      return ValidUserType.create(new ValidEnrollmentTrackingUserType(new DirectorUserType()));
    case EnrollTrackRole.Manager:
      return ValidUserType.create(new ValidEnrollmentTrackingUserType(new ManagerUserType()));
    case EnrollTrackRole.Employer:
      return ValidUserType.create(new ValidEnrollmentTrackingUserType(new EmployerUserType()));
    case EnrollTrackRole.ClientOnboarding:
      return ValidUserType.create(new ValidEnrollmentTrackingUserType(new ClientOnboardingUserType()));
    case EnrollTrackRole.EnrollmentTechnologyPartner:
      return ValidUserType.create(new ValidEnrollmentTrackingUserType(new EnrollmentTechnologyPartnerUserType()));
    case EnrollTrackRole.Broker:
      return ValidUserType.create(new ValidEnrollmentTrackingUserType(new BrokerUserType()));
    case EnrollTrackRole.EtsDataOperations:
      return ValidUserType.create(new ValidEnrollmentTrackingUserType(new EtsDataOperationsUserType()));
    case EnrollTrackRole.EtsEnrollmentOperations:
      return ValidUserType.create(new ValidEnrollmentTrackingUserType(new EtsEnrollmentOperationsUserType()));
    case EnrollTrackRole.SalesSupport:
      return ValidUserType.create(new ValidEnrollmentTrackingUserType(new SalesSupportUserType()));
    case EnrollTrackRole.SalesDistribution:
      return ValidUserType.create(new ValidEnrollmentTrackingUserType(new SalesDistributionUserType()));
    case EnrollTrackRole.Agent:
      return ValidUserType.create(new ValidEnrollmentTrackingUserType(new EnrollTrackAgentUserType()));
    case EnrollTrackRole.EtsLeadership:
      return ValidUserType.create(new ValidEnrollmentTrackingUserType(new EtsLeadershipUserType()));
    default:
      return new InvalidUserType(new InvalidEnrollmentTrackingUserType());
  }
};

const initializeBeneficiariesByRole = (action: ReturnType<typeof changeBeneficiariesRole>) => {
  const {beneficiariesRole} = action.payload;

  switch (beneficiariesRole) {
    case BeneficiariesRole.Admin:
      return ValidUserType.create(new ValidBeneficiariesUserType(new BeneficiariesAdminUserType()));
    default:
      return new InvalidUserType(new InvalidBeneficiariesUserType());
  }
};

const initializeAppEntryByRole = (action: ReturnType<typeof changeAppEntryRole>) => {
  const {appEntryRole} = action.payload;

  switch (appEntryRole) {
    case AppEntryRole.Keyer:
      return ValidUserType.create(new ValidAppEntryUserType(new KeyerUserType()));
    default:
      return new InvalidUserType(new InvalidAppEntryUserType());
  }
};

const initializeBosToolsByRole = (action: ReturnType<typeof changeBosToolsRole>) => {
  const {bosToolsRole} = action.payload;

  switch (bosToolsRole) {
    case BosToolsRole.Admin:
      return ValidUserType.create(new ValidBosToolsUserType(new BosToolsAdminUserType()));
    default:
      return new InvalidUserType(new InvalidBosToolsUserType());
  }
};

const initializeMessagingByRole = (action: ReturnType<typeof changeMessagingRole>) => {
  const {messagingRole} = action.payload;

  switch (messagingRole) {
    case MessagingRole.Admin:
      return ValidUserType.create(new ValidMessagingUserType(new MessagingAdminUserType()));
    case MessagingRole.Manager:
      return ValidUserType.create(new ValidMessagingUserType(new MessagingManagerUserType()));
    case MessagingRole.MessageSender:
      return ValidUserType.create(new ValidMessagingUserType(new MessageSenderUserType()));
    case MessagingRole.MessageAnalyst:
      return ValidUserType.create(new ValidMessagingUserType(new MessageAnalystUserType()));
    default:
      return new InvalidUserType(new InvalidMessagingUserType());
  }
};

export default (state: UserEntryState = DEFAULT_STATE, action: UserEntryAction): UserEntryState => {
  if (
    isFieldSalesLeaderUserTypeAction(action) ||
    isAgentUserTypeAction(action) ||
    isAgentSupportUserTypeAction(action) ||
    isFieldVicePresidentUserTypeAction(action) ||
    isVipUserTypeAction(action)
  ) {
    const existingUserTypes: I.List<UserType> = state.userTypes;
    const userTypeToUpdate = existingUserTypes.find(ut =>
      matchUserTypeByLineOfBusiness(ut.value, {
        Agent: () => true,
        Default: () => false,
      })
    );

    if (userTypeToUpdate) {
      const updatedUserType = matchUserTypeByLineOfBusiness(userTypeToUpdate.value, {
        Agent: updateAgentUserType(action),
        Default: () => userTypeToUpdate,
      });

      return U.changeUserType(updatedUserType)(state);
    } else {
      return state;
    }
  }

  switch (action.type) {
    case UserEntryActionType.SHOW_ERROR:
      const {user} = action.payload;
      return U.showError(user);
    case UserEntryActionType.UPDATE_USER:
    case UserEntryActionType.ADD_USER:
    case UserEntryActionType.GET_USER_DETAIL:
      return new U.LoadingUser(state.basicInformation, state.userTypes);
    case UserEntryActionType.CHANGE_ACCOUNT_TYPE:
      return U.changeAccountType(action.payload.accountType)(state);
    case UserEntryActionType.CHANGE_FIRST_NAME:
      return U.changeFirstName(action.payload.firstName)(state);
    case UserEntryActionType.CHANGE_LAST_NAME:
      return U.changeLastName(action.payload.lastName)(state);
    case UserEntryActionType.CHANGE_USER_NAME:
      return U.changeUserName(action.payload.username)(state);
    case UserEntryActionType.CHANGE_PHONE:
      return U.changePhoneNumber(action.payload.phoneNumber)(state);
    case UserEntryActionType.CHANGE_EMAIL:
      return U.changeEmail(action.payload.email)(state);
    case UserEntryActionType.ADD_USER_TYPE:
      const {lineOfBusiness} = action.payload;
      const newUserType = getUserTypeFromLineOfBusiness(lineOfBusiness);

      return U.addUserType(newUserType)(state);
    case UserEntryActionType.REMOVE_USER_TYPE:
      return U.removeUserType(ValidUserType.create(action.payload.userType))(state);
    case UserEntryActionType.CHANGE_AGENT_ROLE: {
      const existingUserTypes: I.List<UserType> = state.userTypes;
      const userTypeToUpdate = existingUserTypes.find(
        ut => ut.value.key === 'InvalidAgentUserType' || ut.value.key === 'ValidAgentUserType'
      );

      if (userTypeToUpdate) {
        const updatedUserType = matchUserTypeByLineOfBusiness(userTypeToUpdate.value, {
          Agent: () => initializeAgentByRole(action),
          Default: () => userTypeToUpdate,
        });
        return U.changeUserType(updatedUserType)(state);
      } else {
        return state;
      }
    }
    case UserEntryActionType.CHANGE_ENROLL_TRACK_ROLE: {
      const existingUserTypes: I.List<UserType> = state.userTypes;
      const userTypeToUpdate = existingUserTypes.find(
        ut => ut.value.key === 'InvalidEnrollmentTrackingUserType' || ut.value.key === 'ValidEnrollmentTrackingUserType'
      );

      if (userTypeToUpdate) {
        const updatedUserType = matchUserTypeByLineOfBusiness(userTypeToUpdate.value, {
          EnrollmentTracking: () => initializeEnrollTrackByRole(action),
          Default: () => userTypeToUpdate,
        });
        return U.changeUserType(updatedUserType)(state);
      } else {
        return state;
      }
    }
    case UserEntryActionType.CHANGE_BENEFICIARIES_ROLE: {
      const existingUserTypes: I.List<UserType> = state.userTypes;
      const userTypeToUpdate = existingUserTypes.find(
        ut => ut.value.key === 'InvalidBeneficiariesUserType' || ut.value.key === 'ValidBeneficiariesUserType'
      );

      if (userTypeToUpdate) {
        const updatedUserType = matchUserTypeByLineOfBusiness(userTypeToUpdate.value, {
          Beneficiaries: () => initializeBeneficiariesByRole(action),
          Default: () => userTypeToUpdate,
        });
        return U.changeUserType(updatedUserType)(state);
      } else {
        return state;
      }
    }
    case UserEntryActionType.CHANGE_APPENTRY_ROLE: {
      const existingUserTypes: I.List<UserType> = state.userTypes;
      const userTypeToUpdate = existingUserTypes.find(
        ut => ut.value.key === 'InvalidAppEntryUserType' || ut.value.key === 'ValidAppEntryUserType'
      );

      if (userTypeToUpdate) {
        const updatedUserType = matchUserTypeByLineOfBusiness(userTypeToUpdate.value, {
          AppEntry: () => initializeAppEntryByRole(action),
          Default: () => userTypeToUpdate,
        });
        return U.changeUserType(updatedUserType)(state);
      } else {
        return state;
      }
    }
    case UserEntryActionType.CHANGE_BOS_TOOLS_ROLE: {
      const existingUserTypes: I.List<UserType> = state.userTypes;
      const userTypeToUpdate = existingUserTypes.find(
        ut => ut.value.key === 'InvalidBosToolsUserType' || ut.value.key === 'ValidBosToolsUserType'
      );

      if (userTypeToUpdate) {
        const updatedUserType = matchUserTypeByLineOfBusiness(userTypeToUpdate.value, {
          BosTools: () => initializeBosToolsByRole(action),
          Default: () => userTypeToUpdate,
        });
        return U.changeUserType(updatedUserType)(state);
      } else {
        return state;
      }
    }
    case UserEntryActionType.CHANGE_MESSAGING_ROLE: {
      const existingUserTypes: I.List<UserType> = state.userTypes;
      const userTypeToUpdate = existingUserTypes.find(
        ut => ut.value.key === 'InvalidMessagingUserType' || ut.value.key === 'ValidMessagingUserType'
      );

      if (userTypeToUpdate) {
        const updatedUserType = matchUserTypeByLineOfBusiness(userTypeToUpdate.value, {
          Messaging: () => initializeMessagingByRole(action),
          Default: () => userTypeToUpdate,
        });
        return U.changeUserType(updatedUserType)(state);
      } else {
        return state;
      }
    }
    case UserEntryActionType.CHANGE_IS_USER_SUPPORT: {
      return U.changeIsUserSupport(action.payload.isUserSupport)(state);
    }
    case UserEntryActionType.CLEAR_STATE:
      return DEFAULT_STATE;
    default:
      return state;
  }
};
